<template>
    <div class="row" id="diary-show">
        <!-- detail column -->
        <div class="col s6">
            <div class="row">
                <div class="col s12">
                    <h3>{{ diary.title }}</h3>
                    <div class="publish-date"><i class="material-icons">access_time</i>Due Date {{ diaryDueDate }}</div>
                </div>
            </div>
            <div class="row">
                <div class="col s12">
                    <h5>Task Descriptions</h5>
                </div>
            </div>
            <div class="row">
                <div class="col s12">
                    <p v-for="(task, index) in diary.tasks">
                        <label>
                            <input type="checkbox" v-on:click="isChecked(task.id, $event)" v-bind:checked="task.status"/>
                            <span v-bind:class="{on : task.status }"><span class="line">{{ task.name }}</span></span>
                        </label>
                    </p>
                </div>
            </div>
            <div class="row" v-if="is_check_save">
                <div class="col s12">
                    <a class="waves-effect waves-light btn" v-on:click="isCheckSubmit">Update</a>
                </div>
            </div>
        </div>
        <!--comment column-->
        <div class="col s6">
            <div class="card-panel">
                <div class="row">
                    <div class="col s12">
                        <h4>Comments</h4>
                    </div>
                </div>
                <div id="comment-container">
                    <div class="row">
                        <div class="input-field col s12">
                            <textarea id="comment-box" v-model="content" placeholder="Write comment here" class="materialize-textarea"></textarea>
                        </div>
                        <div class="col s12">
                            <a class="waves-effect waves-light btn-small" v-on:click="postComment" v-if="content != '' && !is_editing">Submit</a>
                            <a class="waves-effect waves-light btn-small" v-on:click="editComment" v-if="content != '' && is_editing">Edit</a>
                            <a class="waves-effect waves-light btn-small" v-on:click="cancelEditComment" v-if="content != '' && is_editing">Cancel</a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s12">
                            <ul>
                                <li>
                                    <div class="row" v-if="comments.length > 0" v-for="(comment, index) in comments">
                                        <div class="col s12">
                                            <div class="row">
                                                <div class="col s12">
                                                    <div class="row">
                                                        <div class="col s8">
                                                            <div class="username">{{ comment.post_name }}</div>
                                                            <div class="post-date"><i class="material-icons">access_time</i>{{ comment.post_date_diff }}</div>
                                                        </div>
                                                        <div class="col s4 right-align" v-if="comment.user_id == user_id">
                                                            <span class="comment-action" v-on:click="deleteComment(comment, index)"><i class="material-icons">delete</i></span>
                                                            <span class="comment-action" v-on:click="editAction(comment, index)"><i class="material-icons">edit</i></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col s12">
                                                    <p class="content">{{ comment.content }}</p>
                                                </div>
                                            </div>
                                            <div class="divider"></div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="comments.length == 0">
                                        <div class="col s12">
                                            <p> No Comments Available.</p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'

    export default {
        name: 'DiaryShow',

        props: {
            diaryData: String,
            actionUrl: String,
            editUrl: String,
            deleteUrl: String,
            getCommentsUrl: String,
            userId: String,
            diaryDueDate: String,
            checkTaskUrl: String
        },

        data() {
            return {
                diary: '',
                comments: [],
                content: '',
                is_editing: false,
                user_id: null,
                comment_id: null,
                comment_index: null,
                comment_user_id: null,
                is_check_save: false
            }
        },
        mounted() {
            this.diary = JSON.parse(this.diaryData);
            this.user_id = this.userId;

            this.getComments();
        },

        methods: {
            getComments: function () {
                var me = this;
                axios.post(this.getCommentsUrl,
                    {
                        'diary_id' : this.diary.id
                    }).then(response => {

                    if(response.data.success) {
                        me.comments = response.data.comments
                    } else {

                    }

                }).catch(err => {

                });
            },
            postComment: function() {
                var me = this;

                axios.post(this.actionUrl,
                    {
                        'content' : this.content,
                        'diary_id': this.diary.id,

                    }).then(response => {

                    if(response.data.success) {
                        me.comments.unshift(response.data.comment);

                    } else {

                    }

                }).catch(err => {

                });
            },
            deleteComment: function (comment, index) {
                var me = this;

                if (confirm('Are you sure you want to delete this comment?')) {
                    axios.post(this.deleteUrl,
                        {
                            'comment_id' : comment.id,
                            'user_id': comment.user_id
                        }).then(response => {

                        if(response.data.success) {
                            me.comments.splice(index, 1);
                        } else {
                            M.toast({html: 'Error, ' + response.data.messages, classes: 'red accent-2'});
                        }
                    }).catch(err => {

                    })
                } else {
                    // Do nothing!
                }

            },
            editComment: function () {
                var me = this;

                axios.post(this.editUrl,
                    {
                        'content' : this.content,
                        'comment_id': this.comment_id,
                        'user_id': this.comment_user_id,

                    }).then(response => {

                    if(response.data.success) {
                        me.comments[this.comment_index].content = response.data.comment.content;
                        me.cancelEditComment();
                    } else {
                        M.toast({html: 'Error, ' + response.data.messages, classes: 'red accent-2'});
                    }
                }).catch(err => {

                })
            },
            editAction: function(comment, index) {
                var me = this;

                this.is_editing = true;
                this.content = comment.content;
                this.comment_id = comment.id;
                this.comment_index = index;
                this.comment_user_id = comment.user_id;
            },
            cancelEditComment: function() {
                var me = this;

                this.is_editing = false;
                this.content = '';
                this.comment_id = null;
                this.comment_index = null;
                this.comment_user_id = null;
            },
            isChecked: function (id, event) {
                var me = this;

                this.is_check_save = true;

                for (var i=0; i < this.diary.tasks.length; i++)
                {
                    if (this.diary.tasks[i].id === id)
                    {
                        if (event.target.checked)
                        {
                            this.diary.tasks[i].status = 1;
                        }
                        else {
                            this.diary.tasks[i].status = 0;
                        }
                    }
                }
            },
            isCheckSubmit: function() {
                var me = this;

                M.toast({html: 'Saving...', classes: 'saving_toast'});
                let savingToastInstance = M.Toast.getInstance(document.querySelector('.saving_toast'));

                axios.post(this.checkTaskUrl,
                    {
                        'tasks' : this.diary.tasks,
                    }).then(response => {

                    if(response.data.success) {
                        savingToastInstance.dismiss();
                        M.toast({html:  response.data.messages, classes: 'toast-background-color'});
                        me.is_check_save = false;
                    } else {
                        M.toast({html: 'Error, ' + response.data.messages, classes: 'red accent-2'});
                    }
                }).catch(err => {

                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    #diary-show {
        .username {
            font-weight: bold;
            font-size: 18px;
        }
        .publish-date {
            i {
                font-size: 16px;
                position: relative;
                top: 2px;
                margin-right: 5px;
            }
        }
        .post-date {
            font-size: 12px;
            color: #9e9e9e;
            i {
                font-size: 14px;
                position: relative;
                top: 2px;
                margin-right: 5px;
            }
        }
        .comment-action {
            i {
                font-size: 18px;
                cursor: pointer;
            }
        }
        .divider {
            margin-top: 5px;
            margin-bottom: 5px;
        }

        .line {
            display: inline-block;
            position: relative;
            padding: 0 0.1em;

            &::before {
                content: '';
                position: absolute;
                display: block;
                height: 0;
                left: 0;
                top: 50%;
                width: 0;
                border-bottom: 2px solid #9e9e9e;
                transition: width 200ms linear;
            }
        }
        .on .line:before {
            width: 100%;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/diaries/DiaryShow.vue